import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-edit-icon',
  templateUrl: './edit-icon.component.html',
  styleUrls: ['./edit-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
